// AnimatedText.js
import React from "react";
import '../styles/Textanimation.css';
import { useInView } from "react-intersection-observer";
// import styles from "../../styles/AnimatedText.module.css";
const AnimatedText = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // animate only once when it first comes into view
    threshold: 0.1,    // trigger when 10% of the component is in view
  });
  return (
    <div ref={ref} className={`container ${inView ? "animate" : ""}`}>
      <div className="text a"> Full-Service </div>
      {/* <div className="text b"> </div> */}
      <div className="text b"> for </div>
      <div className="text c"> Shopify  </div>
      <div className="text d"> & </div>
      <div className="text e"> Landing </div>
      <div className="text f"> Page </div>
      <div className="text g"> for </div>
      <div className="text h"> Your </div>
      <div className="text i"> Brand </div>
    </div>
  );
};
export default AnimatedText;